export default __webpack_public_path__ + "static/media/partner-landing-page-img.eb087745.png";